const DEFAULT_ERROR_MESSAGE = "Something went wrong";

export const handleResponseError = (error) =>
  error?.response?.data?.errors?.[0]?.detail ||
  error?.message ||
  DEFAULT_ERROR_MESSAGE;
